import { render, staticRenderFns } from "./authForgotPasswordHelpDialog.vue?vue&type=template&id=308b96a6&scoped=true"
import script from "./authForgotPasswordHelpDialog.vue?vue&type=script&lang=js"
export * from "./authForgotPasswordHelpDialog.vue?vue&type=script&lang=js"
import style0 from "./authForgotPasswordHelpDialog.vue?vue&type=style&index=0&id=308b96a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308b96a6",
  null
  
)

export default component.exports